import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';
import EzModalController from 'layouts/modal/modal-controller';

export default class LicenseSelectorFreeModalController extends EzModalController {
  connect() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_connects);
    super.connect();
  }

  close = (event) => {
    triggerCustomEvent(events.show_page.license_selector_free_modal_closes);
    super.close(event);
  }

  sendFreeLicenseEvent() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_free_button, {
      licenseType: 'free_license',
    });
    triggerCustomEvent(events.download_btn.match_eezycore_free_dupe);
  }

  sendProLicenseEvent() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_pro_button, {
      licenseType: 'pro_license',
    });
  }

  sendCopyAttrEvent() {
    triggerCustomEvent(events.show_page.attribution_link_copied);
  }

  sendLearnMoreEvent() {
    triggerCustomEvent(events.show_page.license_selector_free_modal_learn_more);
  }
}
